const axios = require('axios');
const { baseUrlNew, buildAuthHeaders } = require('./settings.js');

// Get event tracking errors summary (overview with daywise and eventwise counts)
exports.getErrorsSummary = function (params) {
  return axios.post(baseUrlNew + 'event-tracking-errors/summary', params, {
    headers: buildAuthHeaders()
  });
};

// Get paginated event tracking error details
exports.getErrorDetails = function (params) {
  return axios.post(baseUrlNew + 'event-tracking-errors/detail', params, {
    headers: buildAuthHeaders()
  });
};
